import React from 'react'
import DistributionSVG from '../../shared/icons/DistributionSVG'
import AmbulanceSVG from '../../shared/icons/AmbulanceSVG'
import WarehouseSVG from '../../shared/icons/WarehouseSVG'
import SupportSVG from '../../shared/icons/SupportSVG'

const HomeAboutItem = ({ icon, title, text }) => {
  const getIcon = icon => {
    switch (icon) {
      case 'DistributionSVG':
        return <DistributionSVG className="dealmed-home-about__item-icon" />
      case 'AmbulanceSVG':
        return <AmbulanceSVG className="dealmed-home-about__item-icon" />
      case 'WarehouseSVG':
        return <WarehouseSVG className="dealmed-home-about__item-icon" />
      case 'SupportSVG':
        return <SupportSVG className="dealmed-home-about__item-icon" />
      default:
        break
    }
  }

  return (
    <li className="dealmed-home-about__item">
      <div className="dealmed-home-about__item-header">
        <span className="dealmed-home-about__item-icon-wrapper">{getIcon(icon)}</span>
        <h2 className="dealmed-home-about__item-title">{title}</h2>
      </div>
      <div className="dealmed-home-about__item-body">
        <p className="dealmed-home-about__item-text">{text}</p>
      </div>
    </li>
  )
}

export default HomeAboutItem
